import { useState } from 'react';
import PropTypes from 'prop-types';
import { toAudString } from 'utils/currency';
import { Link } from 'components/UI/Link/Link';
import { RemoveCertificatePrompt } from 'components/Cart/Prompts/RemoveCertificatePrompt';

export const RedeemedVouchers = (props) => {
  const { items, stepName } = props;

  const [certItem, setCertItem] = useState(null);

  const handleRequestPromptClose = () => {
    setCertItem(null);
  };

  const requestRemoveCert = (GiftCertificateNumber, Amount) => {
    setCertItem({
      GiftCertificateNumber,
      Amount,
    });
  };

  return (
    <>
      <RemoveCertificatePrompt
        active={!!certItem}
        giftCertificate={certItem}
        onRequestClose={handleRequestPromptClose}
        stepName={stepName}
        forceBackToCurrentPage
      />

      {items.map((voucher) => (
        <div key={voucher.GiftCertificateNumber}>
          <hr />
          <div className="cart-total-wrap cart-delv-total redeem-vouchers-cart-payment">
            <div className="row visible-xs">
              <div className="col-xs-8">
                <div className="row-heading">Redeemed Gift Voucher</div>
              </div>
              <div className="col-xs-4 text-right">
                <div className="row-heading">Price</div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-8">
                <strong>{voucher.ObfuscatedNumber}</strong>
              </div>
              <div className="col-xs-4 text-right">{toAudString(voucher.Amount)}</div>
            </div>
            <Link
              href="#"
              extendClass="link-bold cart-remove pull-right "
              onClick={() => {
                requestRemoveCert(voucher.GiftCertificateNumber, voucher.Amount);
              }}
              variant="secondary"
            >
              Remove
            </Link>
          </div>
        </div>
      ))}
    </>
  );
};

RedeemedVouchers.propTypes = {
  items: PropTypes.array.isRequired,
  stepName: PropTypes.string,
};
